export default "__VITE_ASSET__DJJfNAbX__"